import { TemplateResult, html, LitElement} from 'lit';
import { customElement, property } from 'lit/decorators.js'
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './styles/outline-section-header.global.pcss?inline';
import innerStyles from './styles/outline-section-header.base.pcss?inline';
import { SlotHelper } from '../../controllers/slot-helper';

export const backgroundColors = ['primary-subtler', 'neutral-subtler', 'neutral-subtlest'];
export type BackgroundColor = (typeof backgroundColors)[number];

/**
 * The OutlineSectionHeader component
 * @element outline-section-header
 */
@customElement('outline-section-header')
export class OutlineSectionHeader extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });

  private _slotHelper = new SlotHelper(this);

  @property({ type: Boolean, attribute: 'has-cta' })
  hasCta: boolean;

  @property({ type: Boolean, attribute: 'has-heading' })
  hasHeading: boolean;

  @property({ type: Boolean, attribute: 'has-description' })
  hasDescription: boolean;

  @property({type: String, attribute: 'background-color', reflect: true})
  background: BackgroundColor;

  render(): TemplateResult {
    this.hasCta = this._slotHelper.isNotEmpty('cta');
    this.hasHeading = this._slotHelper.isNotEmpty('heading');
    this.hasDescription = this._slotHelper.isNotEmpty('description');

    return html`
    <outline-container>
      <section class="outline-section-header ${this.background}">
        <div class="main-content-wrapper">
          <slot name="heading"></slot>
          <slot name="description"></slot>
        </div>
        <div class="cta-wrapper">
          <slot name="cta"></slot>
        </div>
      </section>
    </outline-container>
    `;
  }
}

// Declare the custom element for TypeScript
declare global {
  interface HTMLElementTagNameMap {
    'outline-section-header': OutlineSectionHeader;
  }
}
